import {
  type PostTicketedEvent,
  type PutTicketedEvent,
} from '@/modules/Campaigns';
import { createApiRequest } from '@/utils/services';

type PostTicketedEventRequest = {
  data: PostTicketedEvent;
  method: string;
  path: string;
  throwErrors: boolean;
};

type PutCampaignEventRequest = {
  data: PutTicketedEvent;
  method: string;
  path: string;
  throwErrors: boolean;
};

type CampaignEventResponse = APIResponse<{ ticketedEvent: TicketedEvent }>;

type PostCampaignEventTicketRequest = {
  data: {
    orgId: string;
    ticketedEventId: string;
  };
  method: string;
  path: string;
  throwErrors: boolean;
};

type PutCampaignEventTicketRequest = {
  data: CampaignEventTicket;
  method: string;
  path: string;
  throwErrors: boolean;
};

type CampaignEventTicketResponse = APIResponse<{
  ticket: CampaignEventTicket;
}>;

export const createCampaignEvent = (eventData: PostTicketedEvent) =>
  createApiRequest<PostTicketedEventRequest, CampaignEventResponse>({
    data: eventData,
    method: 'post',
    path: 'events',
    throwErrors: true,
  });

export const updateCampaignEvent = (eventData: PutTicketedEvent) =>
  createApiRequest<PutCampaignEventRequest, CampaignEventResponse>({
    data: eventData,
    method: 'put',
    path: `events/${eventData.ticketedEventId}`,
    throwErrors: true,
  });

export const createTicketOption = (
  ownerOrgId: string,
  ticketedEventId: string,
  data: CampaignEventTicket,
) =>
  createApiRequest<PostCampaignEventTicketRequest, CampaignEventResponse>({
    data: {
      orgId: ownerOrgId,
      ticketedEventId,
      ...data,
    },
    method: 'post',
    path: 'tickets',
    throwErrors: true,
  });

export const updateTicketOption = (data: CampaignEventTicket) =>
  createApiRequest<PutCampaignEventTicketRequest, CampaignEventTicketResponse>({
    data,
    method: 'put',
    path: `tickets/${data.ticketId}`,
    throwErrors: true,
  });

export default {
  createCampaignEvent,
  updateCampaignEvent,
  createTicketOption,
  updateTicketOption,
};
